import { Anchor } from '@components/Anchor';
import { TableCellAction } from '@components/Table/TableCellAction';
import { TableHeaderCell } from '@components/Table/TableHeaderCell';
import { TableHeaderCellAction } from '@components/Table/TableHeaderCellAction';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { TableLinearLoading } from '@components/Table/TableLinearLoading';
import { TableNoResult } from '@components/Table/TableNoResult';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { IMenu } from '@hooks/useMenu';
import { useModalWindow } from '@hooks/useModalWindow';
import { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { FaturaDetalheModal } from '@mod/Fatura/FaturaDetalheModal';
import IFatura, { useFaturaTipoColor } from '@model/Fatura';
import { useFaturaStatusColor } from '@model/FaturaStatus';
import { IFaturaFilter } from '@services/ClienteService';
import React from 'react';

export type FaturaTableProps = {
    data: IData<IFatura, IFaturaFilter>
    isLoading: boolean
    menu: IMenu
}

export function FaturaTable ({ data, isLoading, menu }: FaturaTableProps) {
    const formatter = useFormatter();
    const faturaStatusColor = useFaturaStatusColor();
    const faturaTipoColor = useFaturaTipoColor();

    const faturaDetalheModal = useModalWindow();

    return (
        <React.Fragment>
            <TableLinearLoading isLoading={isLoading} />

            <TableNoResult itemCount={data.itemsCount}>
                <TableHead>
                    <TableRow>
                        <TableHeaderCell>ID</TableHeaderCell>
                        <TableHeaderCell>Empresa</TableHeaderCell>
                        <TableHeaderCell>Vencimento</TableHeaderCell>
                        <TableHeaderCell>Vlr. Total</TableHeaderCell>
                        <TableHeaderCell>Vlr. Pago</TableHeaderCell>
                        <TableHeaderCell>Saldo</TableHeaderCell>
                        <TableHeaderCell>Pagamento</TableHeaderCell>
                        <TableHeaderCell>Forma Pgto.</TableHeaderCell>
                        <TableHeaderCell>Tipo</TableHeaderCell>
                        <TableHeaderCell>Status</TableHeaderCell>
                        <TableHeaderCellAction />
                    </TableRow>
                </TableHead>

                <TableBody>
                {
                    data.items.map((fatura, index) => {
                        return (
                            <TableRow key={index}>
                                <TableKeyCell><Anchor onClick={data.handleRowFocused(fatura, faturaDetalheModal.open)}>{fatura.faturaId}</Anchor></TableKeyCell>
                                <TableCell>{fatura.empresaNome}</TableCell>
                                <TableCell>{formatter.toDate(fatura.dataVencimento)}</TableCell>
                                <TableCell>{formatter.toFloat(fatura.valorTotal)}</TableCell>
                                <TableCell>{formatter.toFloat(fatura.valorPago)}</TableCell>
                                <TableCell>{formatter.toFloat(fatura.saldo)}</TableCell>
                                <TableCell>{formatter.toDate(fatura.dataPagamento)}</TableCell>
                                <TableCell>{fatura.formaPagamentoNome}</TableCell>
                                <TableCell className={faturaTipoColor[fatura.tipo]}>
                                        { fatura.tipo }
                                </TableCell>
                                <TableCell className={faturaStatusColor[fatura.faturaStatusId]}>{fatura.faturaStatusNome}</TableCell>
                                <TableCellAction onButtonClick={data.handleRowFocused(fatura, menu.open)} />
                            </TableRow>
                        )
                    })
                }
                </TableBody>
            </TableNoResult>

            {
                data.focusedRow !== undefined && (
                    <FaturaDetalheModal 
                        faturaId={data.focusedRow.faturaId}
                        modal={faturaDetalheModal}
                    />
                )
            }
        </React.Fragment>
    )
}